import '@/plugins/validators';
import Vue from 'vue';
// import VeeValidate from 'vee-validate';
// import nl from 'vee-validate/dist/locale/nl';

import dayjs from 'dayjs';

// Vue.use(VeeValidate, {
//   locale: nl,
//   classes: true,
//   events: 'blur'
// });

Vue.filter('format_gender', value => {
	return { Male: 'Dhr.', Female: 'Mevr.' }[value] || value;
});

Vue.filter('format_date', value => {
	return dayjs(value).format('LL');
});

Vue.filter('currency', value => {
	return value ? `€ ${value}` : '';
});
